<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="machineYearConfigQueryForm"
        :model="machineYearConfigQueryForm"
        label-width="100px"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="年代机名称">
              <el-input  clearable  v-model="machineYearConfigQueryForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getMachineYearConfigList">查询</el-button>
            <el-button type="primary" @click="addImei">创建</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="编号"> </el-table-column>
        <el-table-column prop="name" label="年代机名称"> </el-table-column>
        <el-table-column prop="startYear" label="开始年份"> </el-table-column>
        <el-table-column prop="endYear" label="结束年份"> </el-table-column>
         <el-table-column prop="sortNum" label="排序"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editorMachineYearConfig(scope.row)" type="text" size="small"
              >编辑</el-button
            >
             <el-button @click="deleteMachineYearConfig(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑年代机设置' : '添加年代机设置'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="machineYearConfigEditForm"
            :model="machineYearConfigEditForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="machineYearConfigEditForm.id"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="年代机名称" prop="name">
              <el-input clearable v-model="machineYearConfigEditForm.name"></el-input>
            </el-form-item>
            <el-form-item label="开始年份" prop="startYear">
              <el-input clearable v-model="machineYearConfigEditForm.startYear"></el-input>
            </el-form-item>
             <el-form-item label="结束年份" prop="endYear">
              <el-input clearable v-model="machineYearConfigEditForm.endYear"></el-input>
            </el-form-item>
             <el-form-item label="排序号" prop="sortNum">
              <el-input clearable v-model="machineYearConfigEditForm.sortNum"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      machineYearConfigQueryForm: {
        name: null,
      },
      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: "sku_memory",
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      machineYearConfigEditForm: {
        id: null,
        imei: null,
        gradeId: null,
        status: 0
      },

      editorFormRules: {
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      fullscreenLoading:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteMachineYearConfig(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteMachineYearConfig({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getMachineYearConfigList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getMachineYearConfigList();
    },

    // 获取表格数据
    getMachineYearConfigList() {
      let self = this;
      self.$api
        .listSearchMachineYearConfig({
          page: self.currentPage,
          size: self.pageSize,
          name: self.machineYearConfigQueryForm.name || null
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addImei() {
      this.dlgType = "new";
      this.machineYearConfigEditForm=this.$options.data().machineYearConfigEditForm;
      this.$nextTick(()=>{
          this.$refs['machineYearConfigEditForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editorMachineYearConfig(row) {
      let self = this;
      self.machineYearConfigEditForm = {
        id: null,
        name: null,
        startYear: null,
        endYear: null,
        sortNum: null,
      };
      self.dlgType = "change";
      for (let i in self.machineYearConfigEditForm) {
          if (row[i]) self.machineYearConfigEditForm[i] = row[i];
      }
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["machineYearConfigEditForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.machineYearConfigEditForm) {
            params[i] = this.machineYearConfigEditForm[i];
          }
          if (self.dlgType === "change") {
            self.$api.updateMachineYearConfig({
              id:self.machineYearConfigEditForm.id,
              name:self.machineYearConfigEditForm.name,
              startYear:self.machineYearConfigEditForm.startYear,
              endYear:self.machineYearConfigEditForm.endYear,
              sortNum:self.machineYearConfigEditForm.sortNum}).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getMachineYearConfigList();
                self.closeEditormodelDlg();
              }
            });
          } else {
            self.$api.addMachineYearConfig({
              name:self.machineYearConfigEditForm.name,
              startYear:self.machineYearConfigEditForm.startYear,
              endYear:self.machineYearConfigEditForm.endYear,
              sortNum:self.machineYearConfigEditForm.sortNum
            }).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                self.getMachineYearConfigList();
                self.closeEditormodelDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
  },
  created() {},
  mounted() {
    let self = this;
    self.getMachineYearConfigList();
  },
};
</script>
<style lang="less" scoped></style>
